import mergeAll from 'lodash/fp/mergeAll';
import { MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE } from "../MarketplaceAnalyticsContext/MarketplaceAnalyticsContext";
export const getAllMarketplaceContexts = analyticsContext => {
  return analyticsContext.map(contextItem => {
    // $FlowIgnore -- we know that the <MarketplaceAnalyticsContext /> component will ensure `MarketplaceAnalyticsContextItem` shape
    return contextItem[MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE];
  }).filter(Boolean);
};
export const getMergedMarketplaceContext = analyticsContext => {
  const allContexts = getAllMarketplaceContexts(analyticsContext);
  return mergeAll([{
    attributes: {},
    properties: {}
  }, ...allContexts]);
};